const DEFAULT_DATA = {
    id: null,
    name: null
}
const CLEAR_PRODUCT_INPUTS = 'CLEAR_PRODUCT_INPUTS'


export function productBaseBarcodeReducer(state = '', action) {
    switch (action.type) {
        case "SET_PRODUCT_BASE_BARCODE":
            return action.payload

        case CLEAR_PRODUCT_INPUTS:
            return ''

        default: return state
    }
}

export function baseProductNameReducer(state = '', aciton) {
    switch (aciton.type) {
        case "SET_PRODUCT_BASE_NAME":
            return aciton.payload
        case CLEAR_PRODUCT_INPUTS:
            return ''
        default: return state
    }
}

export function baseProductInitialStockReducer(state = '', aciton) {
    switch (aciton.type) {
        case "SET_PRODUCT_BASE_INITIAL_STOCK":
            return aciton.payload
        case CLEAR_PRODUCT_INPUTS:
            return ''
        default: return state
    }
}


export function productBaseInternalCodeReducer(state = '', action) {
    switch (action.type) {
        case "SET_PRODUCT_BASE_INTERNALCODE":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return ''

        default: return state
    }
}

export function productBasePriceReducer(state = 0, action) {
    switch (action.type) {
        case "SET_PRODUCT_BASE_PRICE":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return null

        default: return state
    }
}

export function productBaseCostReducer(state = 0, action) {
    switch (action.type) {
        case "SET_PRODUCT_BASE_COST":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return null

        default: return state
    }
}

export function unitsReducer(state = [], action) {
    switch (action.type) {
        case "SET_UNITS":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return []
        default: return state
    }
}
export function unitReducer(state = DEFAULT_DATA, action) {
    switch (action.type) {
        case "SET_UNIT":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return DEFAULT_DATA

        default: return state
    }
}

export function productsListReducer(state = [], action) {
    switch (action.type) {
        case 'SET_PRODUCTS_LIST':
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return []
        default: return state
    }
}

export function categoryReducer(state = DEFAULT_DATA, action) {
    switch (action.type) {
        case "SET_CATEGORIE":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return DEFAULT_DATA
        default: return state
    }
}
export function categoriesReducer(state = [], action) {
    switch (action.type) {
        case "SET_CATEGORIES":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return []
        default: return state
    }
}

export function maskPriceReducer(state = '0.00', action) {
    switch (action.type) {
        case "SET_MASK_PRICE": return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return '0.0'
        default: return state
    }
}
export function maskCostReducer(state = '0.00', action) {
    switch (action.type) {
        case "SET_MASK_MASK": return action.payload

        case CLEAR_PRODUCT_INPUTS:
            return '0.0'
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/products/base/reducers.js